import React from "react";

interface OptionsCardProps {
  config?: any;
  onSelect: (nextStep: string) => void;
  onBack?: () => void;
}

const OptionsCard: React.FC<OptionsCardProps> = ({ config, onSelect, onBack }) => {
  const options = config?.options || [];

  return (
    <div className="w-full flex flex-col gap-4">
      {options.length === 0 && (
        <div className="text-gray-500 italic text-center p-4">No options configured.</div>
      )}
      {options.map((opt: any, i: number) => (
        <button
          key={i}
          type="button"
          className="w-full text-left p-6 border-2 border-gray-200 rounded-xl hover:border-[#0B4BB6] hover:bg-[#F9FAFB] transition-colors flex flex-col gap-2"
          onClick={() => onSelect(opt.nextStep)}
        >
          <span className="font-plus-jakarta font-bold text-[#141435] text-[18px]">
            {opt.label || `Option ${i + 1}`}
          </span>
          {opt.description && (
            <span className="text-sm text-[#485D7D] font-plus-jakarta">
              {opt.description}
            </span>
          )}
        </button>
      ))}
      {onBack && (
        <div className="flex flex-row w-full mt-4">
          <button
            type="button"
            className="w-full bg-[#7C8B9D] text-white font-plus-jakarta font-bold text-[15px] py-[12px] px-5 rounded-full hover:bg-[#485D7D] transition-colors"
            onClick={onBack}
          >
            Back
          </button>
        </div>
      )}
    </div>
  );
};

export default OptionsCard;
